import React from 'react'
import Chip from '@material-ui/core/Chip'
import PropTypes from 'prop-types'
import usePill from './usePill'

export const PILL_COLOR = {
    DEFAULT: 'default',
    RED: 'rojo',
    GREEN: 'verde',
    YELLOW: 'amarillo',
    LIGHT_BLUE: 'celeste',
    GRAY08: 'gris08',
    GRAY05: 'gris05',
    GRAY03: 'gris03',
    GRAY01: 'gris01',
    YELLOW_HIGHLIGHT: 'amarillo-highlight',
    PURPLE_HIGHLIGHT: 'violeta-highlight',
    GREEN_HIGHLIGHT: 'verde-highlight'
}

const PillComponent = props => {
    const { deleteIcon, icon, useStyles } = usePill(props)

    const classes = useStyles()

    const getChip = () => {
        const chipProps = {
            className: classes[`root-${props.color}`],
            icon,
            disableRipple: true,
            deleteIcon,
            ...props
        }

        if (props.showRightIcon) {
            chipProps.onDelete = props.onDelete || (() => {
            })
        }

        return <Chip {...chipProps} />
    }

    return getChip()
}

PillComponent.propTypes = {
    label: PropTypes.string,
    onDelete: PropTypes.bool,
    disabled: PropTypes.bool,
    clickable: PropTypes.bool,
    size: PropTypes.oneOf(['small-highLight', 'small', 'medium', 'large']),
    variant: PropTypes.oneOf(['default', 'outlined']),
    color: PropTypes.oneOf([
        PILL_COLOR.DEFAULT,
        PILL_COLOR.RED,
        PILL_COLOR.GREEN,
        PILL_COLOR.YELLOW,
        PILL_COLOR.LIGHT_BLUE,
        PILL_COLOR.GRAY08,
        PILL_COLOR.GRAY05,
        PILL_COLOR.GRAY03,
        PILL_COLOR.GRAY01,
        PILL_COLOR.YELLOW_HIGHLIGHT,
        PILL_COLOR.PURPLE_HIGHLIGHT,
        PILL_COLOR.GREEN_HIGHLIGHT
    ]),
    leftimg: PropTypes.oneOf(['avatar', 'circle', 'star', 'clock', 'circle-color', 'check', 'close', 'none']),
    rightimg: PropTypes.oneOf(['default', 'expand'])
}
export default PillComponent
